import { render } from "./addModuleFreight.vue?vue&type=template&id=79d974d0"
import script from "./addModuleFreight.vue?vue&type=script&lang=js"
export * from "./addModuleFreight.vue?vue&type=script&lang=js"

import "./addModuleFreight.vue?vue&type=style&index=0&id=79d974d0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__